import type {
  CreateWorkflowInput,
  UpdateWorkflowInput,
  WorkflowDetail,
  WorkflowListItem,
} from '@qualibot/shared';
import { api } from './api-client';

export async function listWorkflows(): Promise<WorkflowListItem[]> {
  const { data } = await api.get<{ items: WorkflowListItem[] }>('/api/workflows');
  return data.items;
}

export async function getWorkflow(id: string): Promise<WorkflowDetail> {
  const { data } = await api.get<WorkflowDetail>(`/api/workflows/${id}`);
  return data;
}

export async function createWorkflow(input: CreateWorkflowInput): Promise<WorkflowDetail> {
  const { data } = await api.post<WorkflowDetail>('/api/workflows', input);
  return data;
}

export async function updateWorkflow(
  id: string,
  patch: UpdateWorkflowInput,
): Promise<WorkflowDetail> {
  const { data } = await api.put<WorkflowDetail>(`/api/workflows/${id}`, patch);
  return data;
}

export async function deleteWorkflow(id: string): Promise<void> {
  await api.delete(`/api/workflows/${id}`);
}
